import { Component, OnInit } from "@angular/core";

@Component({
    selector: 'PrivacyPolicy',
    template: `
    <object data="../../assets/Files/PrivacyPolicy.pdf#toolbar=0" type="application/pdf" width="100%" height="700px"></object>
    `
})
export class PrivacyPolicyComponent implements OnInit {
 
    constructor ()
    {}

    ngOnInit()
    {}

}